const VERSION = '2.0.19p'
export default VERSION
